const SCROLLWIDTH_THRESHOLD = 100;

export const getTotalPages = (containerRef: React.RefObject<HTMLDivElement | null>): number => {
  if (containerRef.current?.scrollWidth === 0) {
    return 0;
  }

  const isValidContainer =
    containerRef &&
    containerRef.current &&
    containerRef.current.scrollWidth > SCROLLWIDTH_THRESHOLD &&
    containerRef.current.clientWidth > SCROLLWIDTH_THRESHOLD;

  if (!isValidContainer) {
    return 1;
  }

  return Math.ceil(
    (containerRef.current.scrollWidth - SCROLLWIDTH_THRESHOLD) / containerRef.current.clientWidth,
  );
};
